import { NgModule } from '@angular/core';

import { LayoutConfig } from '@spartacus/storefront';
import { provideConfig } from '@spartacus/core';
import { NyabDocSearchPageModule } from './nyab-doc-search-page/nyab-doc-search-page.module';
import { NyabPaginationModule } from './common/components/nyab-pagination/nyab-pagination.module';
import { NYABHomePageModule } from './nyabhome-page/nyabhome-page.module';

const layoutConfig: LayoutConfig = {
  layoutSlots: {
    header: {
      slots: ['SiteLogo'],
    },
    NYABHomePageTemplate: {
      slots: ['SiteBanner', 'BodyContent'],
    },
    NyabDocumentLibrarySearchPageTemplate: {
      slots: ['BodyContent'],
    },
    footer: {
      slots: [],
    },
  },
};

@NgModule({
  imports: [NYABHomePageModule, NyabDocSearchPageModule, NyabPaginationModule],
  exports: [NYABHomePageModule, NyabDocSearchPageModule, NyabPaginationModule],
  providers: [provideConfig(layoutConfig)],
})
export class CustomFeatureModule { }
